<template>
  <div v-if="editModeEnabled && operationType === operationTypes.BUYING" class="col-12">
    <app-title label="TRANSFERÊNCIA CLIENTE" />
    <div class="operation">
      <div class="row">
        <div class="col-6">
          <label>Nome:</label>
          <p>{{ transferClientDetail?.company || emptyPlaceholder }}</p>
        </div>
        <div class="col-6">
          <label>Banco:</label>
          <p>{{ transferClientDetail?.name || emptyPlaceholder }}</p>
        </div>

        <div class="col-6">
          <label>Agência:</label>
          <p>{{ transferClientDetail?.agency || emptyPlaceholder }}</p>
        </div>
        <div class="col-6">
          <label>Conta:</label>
          <p>{{ transferClientDetail?.account || emptyPlaceholder }}</p>
        </div>

        <div class="col-12">
          <label>PIX:</label>
          <p>{{ transferClientDetail?.pix || emptyPlaceholder }}</p>
        </div>
        <form-button
          class="col-12 form-input"
          title="Enviar e-mail sobre a transferência"
          :loading="loading"
          @clicked="onSubmitAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { notifyPayment } from '@domains/pos-operations/api'
import { handleGlobalError } from '@shared/services/errorHandler'
import { format } from 'date-fns'
import { appTitle, formButton } from 'tb-design_system-web'
import { ref } from 'vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'TransferenciaCliente',

  components: {
    appTitle,
    formButton
  },

  props: {
    editModeEnabled: {
      type: Boolean,
      default: false
    },
    operationType: {
      type: String,
      required: true
    },
    operationTypes: {
      type: Object,
      required: true
    },
    transferClientDetail: {
      type: Object,
      default: () => ({})
    },
    emptyPlaceholder: {
      type: String,
      default: '-'
    },
    operationId: {
      type: [String, Number],
      required: true
    }
  },

  setup(props) {
    const loading = ref(false)

    const onSubmitAction = async () => {
      try {
        loading.value = true
        const body = {
          paymentDeadlineAt: format(new Date(), 'yyyy-MM-dd')
        }
        await notifyPayment(props.operationId, body)
        toast('E-mail enviado com sucesso', {
          theme: 'auto',
          type: 'success',
          dangerouslyHTMLString: true
        })
      } catch (e) {
        handleGlobalError(e)
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      onSubmitAction
    }
  }
}
</script>
